import React, { Component } from "react";
//import "../login/style.scss";
import { Cookies } from "react-cookie";
import { Route, Redirect, Link } from "react-router-dom";
import { observer } from "mobx-react";
import UserStore from "../../stores/UserStore";
import Inner from "../template/Inner";
import Spinner from "react-spinkit";
import api from "../../lib/api";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import { FiX } from "react-icons/fi";
import { Formik } from "formik";
import moment from "moment";

import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

@observer
class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      error: false,
      createModal: false,
      sendInviteEmail: true,
      resultLimit: 10,
      resultOffset: 0,
      resultsFrom: 0,
      resultsTo: 0,
      resultsTotal: 0,
      resultSort: ""
    };
  }

  componentDidMount() {
    const query = new URLSearchParams(window.location.search);
    const limitQ = query.get("limit");
    const offsetQ = query.get("offset");
    const sortQ = query.get("sort");

    if (limitQ && offsetQ) {
      this.setState({
        resultLimit: parseInt(limitQ),
        resultOffset: parseInt(offsetQ)
      });
    }

    if (sortQ) {
      this.setState({
        resultSort: sortQ
      });
    }

    setTimeout(() => {
      this.loadUsers();
    }, 0);
  }

  csv() {
    api.getCSV(
      response => {
        /*var file = new Blob([response], { type: "application/csv" });
        var fileURL = URL.createObjectURL(file);

        // Open new windows and show PDF
        window.open(fileURL);*/

        //IE11 support
        if (window.navigator && window.navigator.msSaveOrOpenBlob && false) {
          let blob = new Blob([response], { type: "text/csv" });
          window.navigator.msSaveOrOpenBlob(blob, "users.csv");
        } else {
          // other browsers
          let file = new File([response], "users.csv", {
            type: "text/csv"
          });

          const isSafari = /^((?!chrome|android).)*safari/i.test(
            navigator.userAgent
          );
          if (isSafari) {
            let blob = new Blob([response], { type: "text/csv" });
            let exportUrl = URL.createObjectURL(blob);
            var e = document.createElement("a");
            e.href = exportUrl;
            e.target = "_self";
            e.setAttribute("download", "download");
            document.body.appendChild(e);
            e.click();
            document.body.removeChild(e);
          } else {
            let exportUrl = URL.createObjectURL(file);
            window.location.assign(exportUrl);
            URL.revokeObjectURL(exportUrl);
          }
        }
      },
      error => {
        //
      }
    );
  }

  loadUsers() {
    api.getUsers(
      this.state.resultLimit,
      this.state.resultOffset,
      this.state.resultSort,
      response => {
        this.setState({
          users: response.users,
          resultsTotal: response.total,
          resultsFrom: response.from,
          resultsTo: response.to
        });
      },
      error => {
        this.setState({ error: true });
      }
    );
  }

  updateHistory() {
    this.props.history.push(
      `${window.location.pathname}?offset=${parseInt(
        this.state.resultOffset
      )}&limit=${parseInt(this.state.resultLimit)}&sort=${
        this.state.resultSort
      }`
    );
  }

  updateLimit(limit) {
    this.setState({
      resultLimit: limit
    });

    setTimeout(() => {
      this.updateHistory();

      this.loadUsers();
    }, 0);
  }

  updateSort(sort) {
    this.setState({
      resultSort: sort
    });

    setTimeout(() => {
      this.updateHistory();

      this.loadUsers();
    }, 0);
  }

  page(type) {
    if (type == "next") {
      this.setState({
        resultOffset: this.state.resultOffset + this.state.resultLimit
      });
    } else if (type == "prev") {
      this.setState({
        resultOffset: this.state.resultOffset - this.state.resultLimit
      });
    } else if (type == "last") {
      this.setState({
        resultOffset: this.state.resultsTotal - this.state.resultLimit
      });
    } else if (type == "first") {
      this.setState({
        resultOffset: 0
      });
    }

    setTimeout(() => {
      this.updateHistory();

      this.loadUsers();
      window.scrollTo(0, 0);
    }, 0);
  }

  pagination() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
          marginBottom: 5,
          alignItems: "center"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
          }}
        >
          <div class="fddorm-group">
            <select
              value={this.state.resultLimit}
              class="form-control"
              onChange={e => {
                this.updateLimit(e.target.value);
              }}
            >
              <option value="10">Show 10</option>
              <option value="25">Show 25</option>
              <option value="50">Show 50</option>
            </select>
          </div>
          <div style={{ marginLeft: 10 }}>
            <strong>
              Showing {this.state.resultsFrom} - {this.state.resultsTo} of{" "}
              {this.state.resultsTotal}
            </strong>
          </div>
          <div style={{ marginLeft: 30 }}>
            <strong>Order by</strong>
          </div>
          <div class="fddorm-group" style={{ marginLeft: 10 }}>
            <select
              value={this.state.resultSort}
              class="form-control"
              onChange={e => {
                this.updateSort(e.target.value);
              }}
            >
              <option value="">Last login (recent)</option>
              <option value="l">Last login (old)</option>
              <option value="a">A-Z</option>
              <option value="z">Z-A</option>
            </select>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row"
          }}
        >
          {this.state.resultsFrom > 1 && (
            <>
              <button
                onClick={() => {
                  this.page("first");
                }}
                class="btn btn-sm btn-secondary"
              >
                First
              </button>
              <div style={{ width: 10 }}></div>
              <button
                onClick={() => {
                  this.page("prev");
                }}
                class="btn btn-sm btn-primary"
              >
                &larr; Previous
              </button>
            </>
          )}
          <div style={{ width: 10 }}></div>
          {this.state.resultsTo < this.state.resultsTotal && (
            <>
              <button
                onClick={() => {
                  this.page("next");
                }}
                class="btn btn-sm btn-primary"
              >
                Next &rarr;
              </button>
              <div style={{ width: 10 }}></div>
              <button
                onClick={() => {
                  this.page("last");
                }}
                class="btn btn-sm btn-secondary"
              >
                Last
              </button>
            </>
          )}
        </div>
      </div>
    );
  }

  users() {
    if (this.state.error) {
      return (
        <div className="centerBox">
          <img src="https://bk.homestack.com/assets/img/not-found.svg" />
          <h2>Unable to load data</h2>
          <p>
            <button
              onClick={() => {
                this.setState({ error: false });
                this.loadUsers();
              }}
            >
              Try again
            </button>
          </p>
        </div>
      );
    }

    if (!this.state.users.length) {
      return (
        <div
          class="d-flex w-100 justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div class="spinner-border text-warning" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      );
    }

    return (
      <section class="admin-content">
        <Modal open={this.state.createModal} onClose={this.handleClose}>
          <div style={styles.modal}>
            <div style={styles.modalTitle}>
              <h2>Create new user</h2>
              <div
                style={{
                  cursor: "pointer",
                  width: 20,
                  height: 20,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
                onClick={() => {
                  this.setState({ createModal: false });
                }}
              >
                <FiX style={styles.menuIcon} />
              </div>
            </div>

            <Formik
              initialValues={{
                display_name: null,
                email: null,
                password: null,
                phone: null
              }}
              validate={values => {
                let errors = {};

                if (!values.display_name) {
                  errors.display_name = "Required";
                }

                if (!values.password) {
                  errors.password = "Required";
                } else if (values.password.length < 6) {
                  errors.password = "Password must be at least 6 characters";
                }

                if (!values.phone) {
                  errors.phone = "Required";
                } else if (values.phone.length < 6) {
                  errors.phone = "Enter a valid phone number";
                }

                if (!values.email) {
                  errors.email = "Required";
                } else if (
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                ) {
                  errors.email = "Invalid email address";
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {
                  values.send_email = this.state.sendInviteEmail;
                  //alert(JSON.stringify(values, null, 2));

                  api.createUser(
                    values,
                    response => {
                      //alert(JSON.stringify(response));
                      this.setState({
                        createModal: false
                      });

                      window.showToastMessage("Success", "New user created");
                      this.loadUsers();
                      //this.setState({ toAgent: response.id });
                    },
                    error => {
                      alert(error.response.data.message);
                    }
                  );

                  setSubmitting(false);
                }, 400);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting
                /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit}>
                  <p>
                    <label for="display_name">Name</label>
                    <input
                      type="text"
                      name="display_name"
                      class="form-control"
                      id="display_name"
                      placeholder="Name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.display_name}
                    />
                    <span className="form-error">
                      {errors.display_name &&
                        touched.display_name &&
                        errors.display_name}
                    </span>
                  </p>

                  <p>
                    <label for="email">Email</label>
                    <input
                      type="email"
                      name="email"
                      class="form-control"
                      id="email"
                      placeholder="Email address"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    />
                    <span className="form-error">
                      {errors.email && touched.email && errors.email}
                    </span>
                  </p>

                  <p>
                    <label for="phone">Phone</label>
                    <input
                      type="text"
                      name="phone"
                      class="form-control"
                      id="phone"
                      placeholder="Phone number"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.phone}
                    />
                    <span className="form-error">
                      {errors.phone && touched.phone && errors.phone}
                    </span>
                  </p>

                  <p>
                    <label for="password">Password</label>
                    <input
                      type="text"
                      name="password"
                      class="form-control"
                      id="password"
                      placeholder="Password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                    />
                    <span className="form-error">
                      {errors.password && touched.password && errors.password}
                    </span>
                  </p>

                  <p>
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.sendInviteEmail}
                            onChange={() => {
                              const tog = !this.state.sendInviteEmail;
                              this.setState({
                                sendInviteEmail: tog
                              });
                            }}
                            value="1"
                          />
                        }
                        label="Send email invite"
                      />
                    </FormGroup>
                  </p>

                  <p>
                    <button
                      class="btn btn-primary"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      Create user{" "}
                      {this.state.sendInviteEmail ? "& send email" : null}
                    </button>
                  </p>
                </form>
              )}
            </Formik>
          </div>
        </Modal>

        <div class="bg-dark">
          <div class="container  m-b-30">
            <div class="row">
              <div class="col-12 text-white p-t-40 p-b-90">
                <div class="float-right">
                  <button
                    style={{ marginRight: 20 }}
                    onClick={() => {
                      this.csv();
                    }}
                    class="btn btn-primary"
                  >
                    <i class=" fe fe-download " /> Download CSV
                  </button>

                  <button
                    onClick={() => {
                      this.setState({ createModal: true });
                    }}
                    class="btn btn-success"
                  >
                    New user
                  </button>
                </div>
                <h4 class="">
                  {" "}
                  <span class="btn btn-white-translucent">
                    <i class="icon-placeholder fe fe-users " />
                  </span>{" "}
                  Users
                </h4>
                {/*<p class="opacity-75 ">
                  We have inherited from Bootstrap 4, with some tweaks we have
                  <br /> created table styles that blend in our design.
                </p>*/}
              </div>
            </div>
          </div>
        </div>

        <div class="container pull-up">
          <div class="row">
            <div class="col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  {this.pagination()}
                  <div class="table-responsive">
                    <table class="table table-hover ">
                      <thead>
                        <tr>
                          <th style={{ width: 50 }}>&nbsp;</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Joined</th>
                          <th>Logins</th>
                          {UserStore.isAdmin() && <th>Agent</th>}
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.users.map(item => (
                          <tr>
                            <td style={{ width: 40 }}>
                              {item.photo ? (
                                <div class="avatar avatar-sm">
                                  <img
                                    src={item.photo}
                                    class="avatar-img rounded-circle"
                                  />
                                </div>
                              ) : (
                                <div class="avatar avatar-sm">
                                  <span class="avatar-title rounded-circle ">
                                    {item.display_name
                                      .split(" ")
                                      .map((n, i, a) =>
                                        i === 0 || i + 1 === a.length
                                          ? n[0]
                                          : null
                                      )
                                      .join("")}
                                  </span>
                                </div>
                              )}
                            </td>
                            <td>
                              {/*<Link to={`/users/${item.id}`}>*/}
                              {item.display_name}
                              {/*</Link>*/}
                            </td>
                            <td>
                              <a href={`mailto:${item.email}`}>{item.email}</a>
                            </td>
                            <td>
                              <a href={`tel:${item.phone}`}>{item.phone}</a>
                            </td>
                            <td>
                              <small>
                                {moment.unix(item.created_epoch).fromNow()}
                              </small>
                            </td>
                            <td>
                              {item.login_count}
                              <br />
                              <small>
                                Last was{" "}
                                {moment.unix(item.last_login_epoch).fromNow()}
                              </small>
                            </td>

                            {UserStore.isAdmin() && (
                              <td>
                                {item.agent_id ? (
                                  <Link
                                    to={`/agents/${item.agent_id}`}
                                    class="text-underline"
                                  >
                                    {item.agent_name}
                                  </Link>
                                ) : (
                                  <em>None set</em>
                                )}
                              </td>
                            )}

                            <td>
                              <Link
                                to={`/users/${item.id}`}
                                class="btn btn-primary"
                              >
                                View
                              </Link>
                            </td>

                            {/*<td>
                      <Button
                        color="primary"
                        component={Link}
                        to={`/users/${item.id}`}
                      >
                        View
                      </Button>
                    </td>*/}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {this.pagination()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  render() {
    return (
      <Inner>
        <div class="content">{this.users()}</div>
      </Inner>
    );
  }
}

const styles = {
  modal: {
    backgroundColor: "#fff",
    padding: 20,
    maxWidth: 500,
    width: "90%",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    position: "absolute"
  },
  modalTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start"
  }
};

export default Users;
